import Template from 'src/modules/concession/messaging/template/Template.vue'

import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'template',
    name: 'Template',
    component: Template,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
